import { MAPPING_TERM_PATH } from './consts';

const customizedType = (T, type, terminologies) => {
  return T.translate(type, {
    notFound: (key) => {
      return (
        terminologies?.find((item) => item.key === MAPPING_TERM_PATH[key])
          ?.displayName || T.translate(key.toUpperCase())
      );
    },
  });
};
export { customizedType };
